// 学生端 code 校验状态
export const checkCodeStatus = {
  NORMAL: 'normal',
  SUCCESS: 'success',
  FAILURE: 'failure',
  LOADING: 'loading',
};

export const NAME_MAX_LEN = 16;